import { HomePageContent } from './types';

export const homePageContent: HomePageContent = {
  welcomeTitle: "Welcome to Rietow Family Dentistry!",
  aboutDentistry: {
    heading: "Rietow Family Dentistry",
    description: `
        At Rietow Family Dentistry, we believe in providing high-quality, compassionate dental care for the whole family.
        Led by Dr. Joseph Rietow, our team is dedicated to creating a comfortable and welcoming environment for all patients.
        Whether you're in need of routine check-ups, advanced cosmetic procedures, or restorative treatments, we are here 
        to ensure your dental health is in great hands.

        With a focus on patient comfort, we use the latest techniques and technologies to make every visit stress-free 
        and efficient. Experience the difference with personalized care tailored to meet your needs. Book an appointment 
        today and let us take care of your smile!
      `,
  },
};
